
// "2026-11-01" -> "01/11/2026"
const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date + "T00:00:00");
  if (isNaN(d)) return "";
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export default function Caption({ slide, filename, isMobile }) {
  const fileName = slide.src.split('/').pop();
  const dateText = formatDate(slide.date);

  const fontSize = isMobile
    ? (slide.width > slide.height ? "3.4vw" : "3.0vw")
    : (slide.width > slide.height ? "16px" : "14px");

  return (
    <>
      {/* Nome file: fascia in alto */}
      <div
        style={{
          left: 0,
          right: 0,
          position: "absolute",
          top: "0px",
          padding: "6px 50px",       /* margine laterale: lascia libero il pallino di selezione a destra */
          margin: "0px",
          boxSizing: "border-box",
          color: "rgba(255, 255, 255, 0.55)",
          background: "rgba(0, 0, 0, 0.5)",
          fontSize: `calc(${fontSize} * 0.9)`,
          textAlign: "center",
        }}
      >
        {fileName}
      </div>

      {/* Didascalia: fascia in basso */}
      <div
        style={{
          left: 0,
          right: 0,
          position: "absolute",
          bottom: "0px",
          padding: "10px",
          margin: "0px",
          boxSizing: "border-box",
          color: "rgba(255, 255, 255, 0.55)",
          background: "rgba(0, 0, 0, 0.5)",
          fontSize: fontSize,
          textAlign: "center",
        }}
      >
        {dateText && <span style={{ whiteSpace: "pre" }}>{dateText + " - "}</span>}
        {slide.description}
      </div>
    </>
  );
}